import HelpCenterModalDoubtsDesktop from "../../components/au.desktop/help-center-modal-doubts";
import HelpCenterModalDoubtsMobile from "../../components/au.mobile/help-center-modal-doubts";
export const SELECT_OFFER_PARAM = "select-offer";
export const SELECT_OFFER_SESSION_KEY = "select-offer";
export const SELECT_PAYMENT_PARAM = "select-payment";
export const SELECT_PAYMENT_SESSION_KEY = "select-payment";
export const CHECKOUTS_SUMMARY_PARAM = "summary";
export const CHECKOUTS_SUMMARY_SESSION_KEY = "summary";

export const SHOW_MODAL_ON_BACK_BUTTON_PATHS = {
    [SELECT_OFFER_PARAM]: {
        param: SELECT_OFFER_PARAM,
        paramKey: "stepid",
        DesktopModal: HelpCenterModalDoubtsDesktop,
        MobileModal: HelpCenterModalDoubtsMobile,
        sessionKey: SELECT_OFFER_SESSION_KEY
    },
    [SELECT_PAYMENT_PARAM]: {
        param: SELECT_PAYMENT_PARAM,
        paramKey: "stepid",
        DesktopModal: HelpCenterModalDoubtsDesktop,
        sessionKey: SELECT_PAYMENT_SESSION_KEY
    },
    [CHECKOUTS_SUMMARY_PARAM]: {
        param: CHECKOUTS_SUMMARY_PARAM,
        paramKey: "stepid",
        DesktopModal: HelpCenterModalDoubtsDesktop,
        sessionKey: CHECKOUTS_SUMMARY_SESSION_KEY
    }
};

export const FINANCE_USER_TYPE = {
    GOOD: "GOOD",
    BAD: "BAD"
};

export const LOAN_APPLICATION_STATUS = {
    APPROVED: "APPROVED",
    UNDER_REVIEW: "UNDER_REVIEW",
    TO_BE_STARTED: "TO_BE_STARTED",
    PAYMENT_PENDING: "PAYMENT_PENDING",
    REJECTED: "REJECTED",
    APPLICATION_IN_PROGRESS: "APPLICATION_IN_PROGRESS"
};
